import {
    FontResourceItem,
    Inject,
    ISimpleControllerConfiguration,
    GameRandom, ResourceItem, ResourceItemType,
    SimpleBaseController,
    SoundType
} from "@denishussar/html5-game-engine";
import {GameModel, GameModalsEnum} from "./Models/GameModel";
import {GameScreenController, IGameScreenControllerOptions} from "./GameScreenController";
import {GameLogic} from "./Logic/GameLogic";
import {AnimationContents} from "./Controllers/AnimationContents";
import {GameEndController} from "./Controllers/GameEnd/GameEndController";
import {PopupBackgroundController} from "./Controllers/Common/PopupBackgroundController";
import {GamePanelController} from "./Controllers/Game/GamePanelController";
import {PauseScreenController} from "./Controllers/Modals/PauseUI/PauseScreenController";
import {RecordScreenController} from "./Controllers/Modals/Record/RecordScreenController";
import {SettingsScreenController} from "./Controllers/Modals/Settings/SettingsScreenController";
import {ExitGameScreenController} from "./Controllers/Modals/ExitGame/ExitGameScreenController";
import {ExitMenuScreenController} from "./Controllers/Modals/ExitMenu/ExitMenuScreenController";
import {ConnectionErrorScreenController} from "./Controllers/Modals/ConnectionError/ConnectionErrorScreenController";
import {HelpMenuScreenController} from "./Controllers/Modals/Help/HelpMenuScreenController";
import {WinUIScreenController} from "./Controllers/GameStatusWindows/WinUIScreenController";
import {LoseUIScreenController} from "./Controllers/GameStatusWindows/LoseUIScreenController";
import {CharChoiceScreenController} from "./Controllers/Modals/CharChoice/CharChoiceScreenController";
import {MiniGameScreenController} from "./Controllers/MiniGame/MiniGameScreenController";
import {DragonBonesResourceItem} from "@denishussar/html5-game-engine";
import {MainMenuContainerController} from "./Controllers/MainMenu/MainMenuContainerController";
import { SoundConstants } from "./Constants/SoundConstants";

export interface IRootControllerOptions {
    version: string
}

export class RootController extends SimpleBaseController {
    $model: GameModel;

    public constructor(@Inject private _options: IRootControllerOptions,
                       @Inject private _random: GameRandom,
                       @Inject private _gameLogic: GameLogic) {
        super("RootController");
        console.log('RootController', this);

        //_random.setSeed(1);
    }

    protected getConfiguration(): ISimpleControllerConfiguration {

        return <ISimpleControllerConfiguration>{
            childControllers: {},
            resources: {
                font0: new FontResourceItem("Impact"),
                gameArt: new ResourceItem("GAMES_SCREEN_JSON", AnimationContents.GAMES_SCREEN_JSON, ResourceItemType.pixiAnimation),
                introArt: new ResourceItem("INTRO_SCREEN_JSON", AnimationContents.INTRO_SCREEN_JSON, ResourceItemType.pixiAnimation),
                streetArt: new ResourceItem("GAMES_STREET_JSON", AnimationContents.GAMES_STREET_JSON, ResourceItemType.pixiAnimation),
                dbPlayerMale: new DragonBonesResourceItem("dbPlayerMale", "/images/dragonBones/male_back/male_back_anim"),
                dbPlayerGirl: new DragonBonesResourceItem("dbPlayerGirl", "/images/dragonBones/girl_back/girl_back_anim"),
                dbPlayerOld: new DragonBonesResourceItem("dbPlayerOld", "/images/dragonBones/old_back/old_back_anim"),
                dbPlayerWoman: new DragonBonesResourceItem("dbPlayerWoman", "/images/dragonBones/woman_back/woman_back_anim"),
                dbPlayerGirlFront: new DragonBonesResourceItem("dbPlayerGirlFront", "/images/dragonBones/girl_front/girl_front_anim"),
                dbPlayerWomanFront: new DragonBonesResourceItem("dbPlayerWomanFront", "/images/dragonBones/woman_front/woman_front_anim"),
                dbPlayerManFront: new DragonBonesResourceItem("dbPlayerManFront", "/images/dragonBones/male_front/male_front_anim"),
                dbPlayerOldFront: new DragonBonesResourceItem("dbPlayerOldFront", "/images/dragonBones/old_front/old_front_anim"),
            },
            modelEvents: {
                "event1": (p1, p2) => {

                }
            },
            modelWatch: {
                "showSpecialWindow": (showSpecialWindow: boolean) => {
                    if (showSpecialWindow) {
                        this.addChildController({
                            animationContent: AnimationContents.HELP_SCREEN_JSON,
                            libraryName: "help_container",
                            view: HelpMenuScreenController,
                            model: this.$model
                        }, "modal");

                    }
                },
                "showTutorial": (showTutorial: boolean) => {
                    if (!showTutorial) {
                        this.removeChildControllerByNameAsync("TutorialPanelController");
                    }
                },
                "showMainMenuContainer": async (showMainMenuContainer: boolean) => {
                    if (!showMainMenuContainer) {
                        await this.removeChildControllerByNameAsync("main_menu_container");
                    } else {
                        if (this.$childControllers['main_menu_container']) {
                            await this.removeChildControllerByNameAsync("main_menu_container");
                        }
                        this.addChildController({
                            animationContent: AnimationContents.MAIN_MENU_SCREEN_JSON,
                            libraryName: "main_menu_container",
                            view: MainMenuContainerController,
                            model: this.$model
                        }, "main_menu_container");

                    }
                },
                "showMiniGame": (showTutorial: boolean) => {
                    if (showTutorial) {
                        this.addChildController({
                            animationContent: AnimationContents.MINI_GAME_SCREEN_JSON,
                            libraryName: "mini_game",
                            view: MiniGameScreenController,
                            model: this.$model
                        }, "MiniGameController");
                    } else {
                        this.removeChildControllerByNameAsync("MiniGameController");
                    }
                },
                "showPlayController": async (showPlayController: boolean) => {
                    if (showPlayController) {
                        this.addChildController({
                            view: GameScreenController,
                            model: this.$model,
                            options: <IGameScreenControllerOptions>{
                                onQuit: async () => {
                                    this.$childControllers.get("introScreen").visible = true;

                                }
                            },
                            x: 0,
                            y: 0
                        }, "GameScreenController");

                        this.addChildController({
                            view: PopupBackgroundController,
                            model: this.$model
                        }, "PopupBackgroundController");


                        this.addChildControllerAsync({
                            view: GameEndController,
                            model: this.$model
                        }, false, "GameEndController");

                        this.addChildControllerAsync({
                            view: GamePanelController,
                            model: this.$model
                        }, false, "BottomPanelController");
                    } else {
                        await this.removeChildControllerByNameAsync("GameScreenController");
                        await this.removeChildControllerByNameAsync("PopupBackgroundController");
                        await this.removeChildControllerByNameAsync("GameEndController");
                        await this.removeChildControllerByNameAsync("BottomPanelController");
                    }
                },
                "modalState": async (modalState: GameModalsEnum) => {
                    const modal = this.$childControllers.get("modal");
                    if (modal) {
                        await this.removeChildControllerByNameAsync("modal");
                    }

                    if (modalState === GameModalsEnum.pause) {
                        this.addChildController({
                            animationContent: AnimationContents.PAUSE_SCREEN_JSON,
                            libraryName: "KK_pause",
                            view: PauseScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.charSelect) {
                        this.addChildControllerAsync({
                            view: CharChoiceScreenController,
                            model: this.$model
                        }, false, "modal");
                    }
                    if (modalState === GameModalsEnum.record) {
                        this.addChildController({
                            animationContent: AnimationContents.RECORD_SCREEN_JSON,
                            libraryName: "record_board",
                            view: RecordScreenController,
                            model: this.$model.records
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.settings) {
                        this.addChildController({
                            animationContent: AnimationContents.SETTINGS_SCREEN_JSON,
                            libraryName: "settings",
                            view: SettingsScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.exitGame) {
                        this.addChildController({
                            animationContent: AnimationContents.EXIT_GAME_SCREEN_JSON,
                            libraryName: "exit_game",
                            view: ExitGameScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.help) {
                        this.addChildController({
                            animationContent: AnimationContents.HELP_SCREEN_JSON,
                            libraryName: "help_container",
                            view: HelpMenuScreenController,
                            model: this.$model
                        }, "modal");

                    }
                    if (modalState === GameModalsEnum.exitMenu) {
                        this.addChildController({
                            animationContent: AnimationContents.EXIT_MENU_SCREEN_JSON,
                            libraryName: "exit_to_menu",
                            view: ExitMenuScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.connectionError) {
                        this.addChildController({
                            animationContent: AnimationContents.CONNECTION_ERROR_SCREEN_JSON,
                            libraryName: "connection_error",
                            view: ConnectionErrorScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.lose) {
                        this.addChildController({
                            view: LoseUIScreenController,
                            model: this.$model
                        }, "modal");
                    }
                    if (modalState === GameModalsEnum.win) {
                        this.addChildController({
                            view: WinUIScreenController,
                            model: this.$model
                        }, "modal");
                    }
                },
                isGameReady: (ready: boolean) => {
                    this._playMusic();
                },
                isSoundsOn: (isOn: boolean) => {
                    this.soundManager.muteSoundsByType(!isOn, SoundType.SFX);
                },
                isMusicOn: (isOn: boolean) => {
                    // this.soundManager.setMasterVolume(isOn ? 1 : 0); // TODO: исправить на выключение музыки
                    this._playMusic();
                }
            },
            sounds: [
                {
                    id: SoundConstants.MUSIC,
                    type: SoundType.Music
                },
                {
                    id: SoundConstants.MENU_MUSIC,
                    type: SoundType.Music
                }
            ]
        };
    }

    protected onInitialize() {
        this._gameLogic.showMainMenuContainer();
        this.soundManager.muteSoundsByType(!this.$model.isSoundsOn, SoundType.ALL);
        this._playMusic();
    }

    protected onLandscape(): void {
        this.display.rotation = 0;
    }

    protected onPortrait(): void {
        this.display.rotation = -3.1415926 / 2;
    }

    private _playMusic() {
        if (this.$model.isMusicOn) {
            if (!this.soundManager.isSoundPlaying(SoundConstants.MENU_MUSIC) && !this.$model.isGameReady) {
                this.soundManager.stop(SoundConstants.MUSIC);
                this.soundManager.play(SoundConstants.MENU_MUSIC, true, 1);
            } else if (!this.soundManager.isSoundPlaying(SoundConstants.MUSIC) && this.$model.isGameReady) {
                this.soundManager.stop(SoundConstants.MENU_MUSIC);
                this.soundManager.play(SoundConstants.MUSIC, true, 1);
            }
        } else {
            this.soundManager.stop(SoundConstants.MUSIC);
            this.soundManager.stop(SoundConstants.MENU_MUSIC);
        }
    }
}
